// extracted by mini-css-extract-plugin
export default {"errorButton":"error_errorButton__Tatd8"};